module.exports = __webpack_public_path__ + "img/face-smiling-hands.d2416958.svg";